import { Box, FormField } from '@amzn/awsui-components-react';
import React from 'react';
import FeedbackStars from '../FeedbackStars/FeedbackStars';

interface RatingContainerProps {
  label: string;
  rating: number;
  setRating: (value: number) => void;
  constraintText?: string;
  'data-testid'?: string;
}

const RatingContainer: React.FC<RatingContainerProps> = ({ label, rating, setRating, constraintText, ...rest }) => (
  <Box variant="div">
    <FormField constraintText={constraintText} data-testid={rest['data-testid'] || null}>
      <FeedbackStars label={label} rating={rating} setRating={setRating} />
    </FormField>
  </Box>
);

export default RatingContainer;
